import React from 'react'
import { Box, Typography } from '@mui/material'
import type { ControlTowerCardStatus } from '../../../../../../pure-js/enums/ControlTowerCardStatus'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { getStatusColors, getStatusLabel } from './controlTowerHelpers'
import {
  buildControlTowerPillSx,
  buildControlTowerStatusDotSx,
  buildControlTowerStatusLabelSx
} from './controlTowerStyles'

interface ControlTowerStatusPillProps {
  status: ControlTowerCardStatus
  testId?: string
}

/** A card's status: a coloured dot and its word. */
export const ControlTowerStatusPill: React.FC<ControlTowerStatusPillProps> = ({ status, testId }) => {
  const { t } = useTranslation()
  const statusColors = getStatusColors(status)
  const statusLabel = getStatusLabel(status, t)

  return (
    <Box data-testid={testId} sx={buildControlTowerPillSx(statusColors.background)}>
      <Box sx={buildControlTowerStatusDotSx(statusColors.color)} />
      <Typography sx={buildControlTowerStatusLabelSx(statusColors.color)}>{statusLabel}</Typography>
    </Box>
  )
}
